var disabled = false;
export function disableUserScale() {
    if (disabled)
        return;
    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });
    disabled = true;
}
